// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCggawYj8CxHiL5qqUDmypCZWJNgpxRg-w",
  authDomain: "cjsoi2025.firebaseapp.com",
  projectId: "cjsoi2025",
  storageBucket: "cjsoi2025.firebasestorage.app",
  messagingSenderId: "782962089402",
  appId: "1:782962089402:web:4e993007f49f8d41689183",
  measurementId: "G-ZS8MMGK2RM"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDiki-6zrsERFwc6Di5A8ZpAej7klkiZiY",
//   authDomain: "cjsoi2025admin.firebaseapp.com",
//   projectId: "cjsoi2025admin",
//   storageBucket: "cjsoi2025admin.firebasestorage.app",
//   messagingSenderId: "324433489326",
//   appId: "1:324433489326:web:8bb37db176f077d686ac3f",
//   measurementId: "G-C9105L51S0"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);